<app-table
    #journalTable
    [gridData]="store.data.getAccountingJournals()"
    [columns]="columns"
    [refreshCallback]="store.api.getAccountingJournals"
    [refreshCallbackFragment]="journalFrag"
    [additionalFilter]="filters()"
    [translatePrefix]="prefix"
    [tableTitle]="prefix + 'labelMulti'"
    [hideCheckboxes]="true"
    [showDelete]="store.isAllowed('madoAccount.update')()"
    [showDetail]="store.isAllowed('madoAccount.update')()"
    (createCallback)="openDialog()"
    (detailCallback)="openDialog($event)"
    (deleteCallbackWithEvent)="deleteItem($event)"
>
    <ng-template pTemplate="accountId" let-item="item">
        @if (item.account) {
            <div>{{ madoAccountToDropdownOptionString(item.account) }}</div>
        }
    </ng-template>

    <ng-template pTemplate="currencyId" let-item="item">
        @if (item.currency) {
            <div>{{ item.currency.code }} - {{ item.currency.name }}</div>
        }
    </ng-template>

    <ng-template pTemplate="isDefault" let-data="data">
        <app-check-or-cross [value]="data"></app-check-or-cross>
    </ng-template>
</app-table>
